import * as React from 'react';
import ItemTypes from './ItemTypes';

interface INameProps {
    item: any;
    onClick: (item: any) => void;
}

const Name = (props: INameProps) => {
    return (
        <span
            className="tree-name"
            onClick={() => {
                props.onClick(props.item);
            }}
        >
            {props.item.name}
        </span>
    );
};

export default Name;
